module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectBigBlack.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectBigBlack.png
// module id = 232
// module chunks = 0